import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  return <section className="py-20 bg-[#fef3e2] px-4" data-id="element-212">
      <div className="max-w-5xl mx-auto" data-id="element-213">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-214">
          {/* Is For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-[#0d9488]" data-id="element-215">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3" data-id="element-216">
              <span className="bg-[#0d9488] text-white p-1 rounded-full" data-id="element-217">
                <Check className="w-5 h-5" data-id="element-218" />
              </span>
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-219">
              <li className="flex items-start gap-3" data-id="element-220">
                <Check className="w-5 h-5 text-[#0d9488] mt-1 shrink-0" data-id="element-221" />
                <span className="text-slate-700 text-lg" data-id="element-222">
                  Tienes 45+ y el patrón de 3am se repite.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-223">
                <Check className="w-5 h-5 text-[#0d9488] mt-1 shrink-0" data-id="element-224" />
                <span className="text-slate-700 text-lg" data-id="element-225">
                  Ya probaste "tips" y necesitas estructura.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-226">
                <Check className="w-5 h-5 text-[#0d9488] mt-1 shrink-0" data-id="element-227" />
                <span className="text-slate-700 text-lg" data-id="element-228">
                  Quieres algo corto, claro y ejecutable.
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Is Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-slate-300" data-id="element-229">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3" data-id="element-230">
              <span className="bg-slate-300 text-slate-600 p-1 rounded-full" data-id="element-231">
                <X className="w-5 h-5" data-id="element-232" />
              </span>
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-233">
              <li className="flex items-start gap-3" data-id="element-234">
                <X className="w-5 h-5 text-slate-400 mt-1 shrink-0" data-id="element-235" />
                <span className="text-slate-600 text-lg" data-id="element-236">
                  Quieres un milagro en 48 horas.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-237">
                <X className="w-5 h-5 text-slate-400 mt-1 shrink-0" data-id="element-238" />
                <span className="text-slate-600 text-lg" data-id="element-239">
                  No estás dispuesta a tocar nada de rutina (aunque sea mínimo).
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-240">
                <X className="w-5 h-5 text-slate-400 mt-1 shrink-0" data-id="element-241" />
                <span className="text-slate-600 text-lg" data-id="element-242">
                  Tienes síntomas severos sin seguimiento médico.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}